import { ProjectAPI } from "../api";
import { Invoice } from "../classes";
import moment from "moment";
import Helper from "../plugins/Helper/Helper";
export class Project {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async updateProject(payload) {
    const { data } = await ProjectAPI.updateProject(payload);
    data.result = new Project(data.result);
    return data.result;
  }
  static async getProjectOverAllAreaData(payload) {
    return Helper.queryMore(getData, payload, 1000)

    async function getData(d){
      const { data } = await ProjectAPI.getProjectOverAllAreaData(d);
      return data.result;
    }
  }

  static async getProjectOverAllProductData(payload) {
    return Helper.queryMore(getData, payload, 1000)

    async function getData(d){
      const { data } = await ProjectAPI.getProjectOverAllProductData(d);
      return data.result;
    }
  }

  static async getProjectOverAllProductCategoryData(payload) {
    return Helper.queryMore(getData, payload, 1000)

    async function getData(d){
      const { data } = await ProjectAPI.getProjectOverAllProductCategoryData(d);
      return data.result;
    }
  }

  static async getProjectOverAllAccountingProductData(payload) {
    return Helper.queryMore(getData, payload, 1000)

    async function getData(d){
      const { data } = await ProjectAPI.getProjectOverAllAccountingProductData(d);
      return data.result;
    }
  }

  static async getProjectOverAllContractData(payload) {
    return Helper.queryMore(getData, payload, 1000)

    async function getData(d){
      const { data } = await ProjectAPI.getProjectOverAllContractData(d);
      return data.result;
    }
  }
  static async getProjectOverAllAreaBookingData(payload) {
    return Helper.queryMore(getData, payload, 1000)

    async function getData(d){
      const { data } = await ProjectAPI.getProjectOverAllAreaBookingData(d);
      return data.result;
    }
  }
  static async getProjectOverAllInvoiceData(payload) {
    return Helper.queryMore(getData, payload, 1000)

    async function getData(d){
      const { data } = await ProjectAPI.getProjectOverAllInvoiceData(d);
      return data.result.map(d => new Invoice(d, true));
    }
  }
  static async getProject(payload) {
    const { data } = await ProjectAPI.getProject(payload);
    data.result = new Project(data.result);
    return data.result;
  }
}
